import { useIntl } from "react-intl";
import { SimpleEntityGridColumn } from "src/app/components/grid/EntityGrid";

const useTrustFlowGridColumns = (): Array<SimpleEntityGridColumn> => {
    const { formatMessage } = useIntl();

    const cellClassRules = {
        "ttf-business": ({ data }: any) => data?.ttf?.startsWith("Business"),
        "ttf-reference": ({ data }: any) => data?.ttf?.startsWith("Reference"),
        "ttf-arts": ({ data }: any) => data?.ttf?.startsWith("Arts"),
        "ttf-recreation": ({ data }: any) => data?.ttf?.startsWith("Recreation"),
        "ttf-computers": ({ data }: any) => data?.ttf?.startsWith("Computers"),
        "ttf-society": ({ data }: any) => data?.ttf?.startsWith("Society"),
        "ttf-regional": ({ data }: any) => data?.ttf?.startsWith("Regional"),
        "ttf-home": ({ data }: any) => data?.ttf?.startsWith("Home"),
        "ttf-science": ({ data }: any) => data?.ttf?.startsWith("Science"),
        "ttf-health": ({ data }: any) => data?.ttf?.startsWith("Health"),
        "ttf-sports": ({ data }: any) => data?.ttf?.startsWith("Sports"),
        "ttf-world": ({ data }: any) => data?.ttf?.startsWith("World"),
        "ttf-shopping": ({ data }: any) => data?.ttf?.startsWith("Shopping"),
        "ttf-games": ({ data }: any) => data?.ttf?.startsWith("Games"),
        "ttf-news": ({ data }: any) => data?.ttf?.startsWith("News"),
        "ttf-adult": ({ data }: any) => data?.ttf?.startsWith("Adult"),
    };

    return [
        {
            field: "domain",
            headerName: formatMessage({ id: "sites.grid.col.domain" }),
            minWidth: 200,
            maxWidth: 200,
        },
        {
            field: "network",
            headerName: formatMessage({ id: "sites.grid.col.pbn" }),
            minWidth: 90,
            maxWidth: 90,
        },
        {
            field: "tf",
            headerName: formatMessage({ id: "sites.grid.col.tf" }),
            filter: "",
            cellClass: "number-cell",
            minWidth: 70,
            maxWidth: 70,
        },
        {
            field: "ttf",
            headerName: formatMessage({ id: "sites.grid.col.ttf" }),
            maxWidth: 250,
            cellClassRules
        },
    ];
};

export default useTrustFlowGridColumns;
